<template>
  <div
    class="index-item-container"
    :class="{ editable }"
    v-show="deleted === 0"
  >
    <div
      class="index-item"
      :class="'index-item-' + template"
      @click="changePage"
      :title="helpTitle"
    >
      <div class="page-number" v-if="!editMode">
        {{ item && item.pageNumber + pagesCountOffset }}
      </div>
      <div class="page-title slate-bold" v-if="!editMode">
        {{
          (item && item.catalog && item.catalog.label) ||
          (item && item.catalog && item.catalog.name)
        }}
      </div>
      <input
        type="text"
        class="page-title slate-bold page-title-edit"
        maxlength="20"
        v-model="tempName"
        v-else
      />
      <div v-if="editable" class="editable-options">
        <div
          class="editable-option btn btn-outline editable-option-save"
          @click="saveEdit"
          title="Save"
          v-if="editMode"
        >
          Save
        </div>
        <div
          class="editable-option"
          @click="setEditMode"
          title="Edit name"
          v-if="!editMode"
        >
          <img src="~@/assets/edit-blk.svg" alt="edit" />
        </div>
        <div
          class="editable-option btn btn-outline editable-option-cancel"
          @click="setEditMode"
          title="Cancel"
          v-else
        >
          Cancel
        </div>
        <div
          class="editable-option"
          @click="setDeleteMode"
          title="Remove"
          v-if="!tempDisable"
        >
          <img src="~@/assets/delete.svg" alt="delete" />
        </div>
      </div>
    </div>
    <div
      class="index-item-products"
      v-if="isFSGTemplate && !editable && sportProducts"
    >
      <div
        class="index-item-product"
        v-for="(product, index) in sportProducts"
        :key="index"
      >
        {{ product }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "IndexItem",
  computed: {
    ...mapState("playbook", ["template"]),
    ...mapGetters("playbook", ["isUATemplate", "isFSGTemplate"]),

    pagesCountOffset() {
      return -2;
    },

    sportProducts() {
      return false;
      /*let productNames = []
      this.item?.catalog?.layouts?.map((layout) => {
        return layout.products.map((product) => {
          return productNames.push(product.name)
        })
      })
      return productNames*/
    },
    helpTitle() {
      return !this.editable
        ? `Go to page ${
            this.item?.pageNumber
          }: ${this.item?.catalog?.name.toUpperCase()}`
        : "Drag and drop to change order";
    },
  },
  methods: {
    ...mapActions("playbook", ["addSportToPlaybook", "editSportName"]),
    changePage() {
      if (this.editable) return false;

      const pageNumber = this.onePageMode
        ? this.item?.pageNumber
        : this.item?.pageNumber - 2 + (this.item?.pageNumber % 2);
      this.$emit("changePage", pageNumber);
    },
    setEditMode() {
      this.tempName = this.item?.catalog?.label;
      this.editMode = !this.editMode;
    },
    async saveEdit() {
      //guardar en la api
      if (this.tempName?.length) {
        this.item.catalog.label = this.tempName.toLowerCase();
        await this.editSportName({
          sport: (this.template + "_" + this.item?.catalog?.name).toLowerCase(),
          name: this.tempName.toLowerCase(),
        });
        //salir de edit mode
        this.editMode = 0;
      }
    },
    setDeleteMode() {
      this.deleted = 1;
      this.addSportToPlaybook({
        sport: {
          name: this.item?.catalog.name,
        },
      });
    },
  },
  props: {
    item: {
      type: Object,
    },
    onePageMode: {
      type: Boolean,
    },
    editable: {
      type: Boolean,
    },
  },
  data() {
    return {
      deleted: 0,
      editMode: 0,
      tempName: "",
      tempDisable: true,
    };
  },
};
</script>

<style lang="scss" scoped>
#app {
  .index-item-container {
    margin: 0 0 0.5em;
    width: 45%;
    .index-item {
      display: flex;
      font-size: 1.3em;
      align-items: center;
      /* font-weight: bold; */
      cursor: pointer;
      .page-number {
        width: 1em;
        font-weight: bold;
        text-align: right;
        margin-right: 1.5em;
      }
      .page-title {
        text-transform: capitalize;
      }

      input.page-title-edit {
        font-family: initial !important;
        font-size: 0.9em;
        width: 60%;
        text-transform: initial !important;
        border: 1px solid black;
        z-index: 10;
      }
    }
    .index-item-products {
      overflow: hidden;
      .index-item-product {
        font-size: 0.9em;
      }
    }
    &.editable {
      border: 1px dashed;
      min-width: 100px;
      .index-item {
        cursor: grab;
        position: relative;
        padding: 1px;
        .editable-options {
          display: flex;
          position: absolute;
          right: 0;
          margin: 1px;
          .editable-option {
            cursor: pointer;
            padding: 0 3px;
            img {
              width: 12px;
              height: 15px;
            }
            &.editable-option-save,
            &.editable-option-cancel {
              margin-top: 1px;
              color: white;
              background-color: black;
              margin-right: 1px;
            }
          }
        }
      }
    }
    &.sortable-chosen,
    &.sortable-ghost {
      cursor: grabbing !important;
      .index-item {
        cursor: grabbing !important;
      }
    }
  }

  .pagination-item {
    .index-item-container {
      &.editable {
        border: none;
        img {
          display: none;
        }
      }
    }
  }
}
</style>